export default __webpack_public_path__ + "static/media/video-converter-pic-1.dfbf4cea.png";